import {
  PUSH_PAYMENT_METHODS,
  RESET_DATA,
  SET_ACCOUNT_DATA,
  SET_NETWORK_ACCOUNT_DATA,
  SET_PAYMENT_METHOD_ACTIVE,
  SET_PAYMENT_METHODS,
} from 'modules/Forms/Billing/types'

const initialState = {
  methods: { data: [], loading: false, loaded: false },
  activeMethod: null,
  networkAccountData: { loaded: false, loading: false },
  accountData: { loaded: false, loading: false },
}

const setPaymentMethodsData = (state, action) => ({
  ...state,
  methods: {
    data: [...action.payload],
    loaded: true,
  },
})

const pushPaymentMethodsData = (state, action) => ({
  ...state,
  methods: {
    ...state.methods,
    data: [...state.methods.data, ...action.payload],
  },
})

const setPaymentMethodActive = (state, { payload }) => ({
  ...state,
  activeMethod: state.methods.data.find(({ method }) => method === payload),
  calculatedData: { ...initialState.calculatedData },
})

const setNetworkAccountData = (state, action) => ({
  ...state,
  networkAccountData: { ...state.networkAccountData, ...action.payload },
})

const setAccountData = (state, action) => {
  const activeMethod = state.activeMethod
  Object.entries(action?.payload ?? {}).forEach(([account = '', data = {}]) => {
    if (activeMethod.method === account) {
      if (!activeMethod.params) {
        activeMethod.params = {}
      }
      activeMethod.params.wallets =
        data?.wallets?.map((wallet) => ({ ...wallet, id: wallet.currency })) ??
        null
    }
  })
  return {
    ...state,
    activeMethod,
    accountData: { ...state.accountData, ...action.payload },
  }
}

const resetData = () => ({
  ...initialState,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAYMENT_METHODS:
      return setPaymentMethodsData(state, action)
    case SET_PAYMENT_METHOD_ACTIVE:
      return setPaymentMethodActive(state, action)
    case SET_NETWORK_ACCOUNT_DATA:
      return setNetworkAccountData(state, action)
    case SET_ACCOUNT_DATA:
      return setAccountData(state, action)
    case PUSH_PAYMENT_METHODS:
      return pushPaymentMethodsData(state, action)
    case RESET_DATA:
      return resetData()

    default:
      return state
  }
}

export default reducer
